export type ContactData = {
	eMail: string
	phone: string
	mobile: string
	fullName?: string
}

export function DefaultContactData(): ContactData {
	return { eMail: '', mobile: '', phone: '', fullName: '' }
}
